import MemberDetailedRowItem from './MemberDetailedRowItem';

export default MemberDetailedRowItem;
